import React from 'react';

const Loading = () => {
    return (

        <div className='justify-center mt-5 flex'>
            <progress class="progress circle w-48 h-2">Loading......</progress>
        </div>

    );
};

export default Loading;